module.exports = __webpack_public_path__ + "static/fonts/iconfont.63a9bd05.eot";